interface Props {
  delta: number;
  /** 増加が「良い」KPI なら true、増加が「悪い」KPI なら false */
  positiveIsGood: boolean;
  suffix: string;
  /** 金額など、絶対値を整形して表示したい場合に指定する */
  formatValue?: (value: number) => string;
}

/**
 * 前期比インジケーター（↑X / ↓X）。
 * 良い変化は Semantic/Primary、悪い変化は Semantic/Accent1 で表示する。
 */
export default function DeltaIndicator({ delta, positiveIsGood, suffix, formatValue }: Props) {
  if (delta === 0) return null;
  const arrow = delta > 0 ? '↑' : '↓';
  const isGood = positiveIsGood ? delta > 0 : delta < 0;
  const magnitude = Math.abs(delta);
  return (
    <span className={`text-heading-xxs ${isGood ? 'text-primary' : 'text-accent1'}`}>
      {arrow}
      {formatValue ? formatValue(magnitude) : magnitude}
      {suffix}
    </span>
  );
}
